import { Layout } from '@enterprise-ui/canvas-ui-react'
import { useAuth } from '@praxis/component-auth'
import { SideNavigation, Header } from 'item-component'
import { MainRouter } from './MainRouter'
import { LogIn } from './LogIn'
import { Unauthorized } from './Unauthorized'
import { LoadingProfile } from './LoadingProfile'
import { useMain } from './useMain'
import { isItemhubDomain } from '../../resources/searchUtills'
import { useEffect, useRef } from 'react'
import '../../styles/customStyles.scss'
import { useFirefly } from '../../utilities/useFirefly'

export const Main = () => {
  const { loading, error, data, getUserProfile } = useMain()
  const { handleTrackViewEvent } = useFirefly() || {}
  const hasTrackedView = useRef(false)

  const appMenus = [
    {
      name: 'Home',
      path: '/',
      reload: false,
      iconName: 'HouseIcon',
      groups: [],
      enabled: true,
    },
  ]
  const auth = useAuth()
  const { isAuthenticated } = auth

  useEffect(() => {
    if (getUserProfile && !hasTrackedView.current) {
      handleTrackViewEvent('bulk_home_page - pageload', 'Bulk Upload')
      hasTrackedView.current = true
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getUserProfile])

  if (isAuthenticated()) {
    if (loading) return <LoadingProfile />
    if (error) return <Unauthorized />
    if (data) {
      return (
        <Layout
          theme="dark" // configure theme here
          darkMode="false" // configure theme here
          data-testid="bulk-layout"
          className="hc-pr-none hc-pl-none hc-pb-none layout-body-section "
        >
          <>
            <Header
              userRole={
                getUserProfile?.roles ? getUserProfile.roles?.join() : ''
              }
              useAuth={useAuth}
              // appTitle={'Launchpad'}
              appTitle={isItemhubDomain ? 'ItemHub' : 'Launchpad'}
              isSupportVisible={true}
            />
            {getUserProfile?.roles?.length > 0 && (
              <SideNavigation
                className="side-navigation-panel"
                data-testid="item-app-sidenav-panel"
                startExpanded={isItemhubDomain}
                appMenus={appMenus}
                // defaultmenurequired={false} //  TODO: For Itemhub --> Need Comment this line and Enable the below line
                defaultmenurequired={isItemhubDomain}
                isMinimized={!isItemhubDomain}
                auth={auth}
              />
            )}
          </>
          <MainRouter getUserProfile={getUserProfile} />
        </Layout>
      )
    }
  } else {
    return <LogIn />
  }
}
